import { useContext } from "react";

import { Grid, Switch, FormControlLabel, Checkbox } from "@material-ui/core";

import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Fieldset from "../../../../components/basics/Fieldset";
import Chip from "../../../../components/basics/Chip";
import SelectErp from "../../../../components/basics/SelectErp";
import {
  HeaderAccordion,
  Line,
  CheckItem,
  Form,
} from "../styles/DespesasReembolsaveis";
import Card from "../../../../components/cards/Card";

import { DespesasReembolsaveisContext } from "../contexts/DespesasReembolsaveisContext";
import useDespesasReembolsaveisController from "../controllers/DespesasReembolsaveisController";

const AccordionDespesasDadosGerais = ({ ...props }) => {
  const {
    companies,
    description,
    setDescription,
    complement,
    setComplement,
    errorsSubmit,
    active,
    setActive,
    service,
    setService,
    serviceList,
  } = useContext(DespesasReembolsaveisContext);

  const { handleCheckCompany } = useDespesasReembolsaveisController();

  return (
    <>
      <Fieldset
        titulo={
          <HeaderAccordion>
            <Grid container spacing={2}>
              <Grid item xs>
                <Chip
                  label="DADOS GERAIS"
                  bgcolor="primary"
                  textcolor="white"
                />
              </Grid>
            </Grid>
          </HeaderAccordion>
        }
        bgcolor="white"
        textcolor="black"
        accordion
        defaultExpanded
      >
        <Line container spacing={1}>
          <Grid container spacing={4}>
            <Grid item xs={2}>
              <TextFieldErp
                label="Descrição *"
                value={description}
                setValue={setDescription}
                maxLength="30"
                size="small"
                error={!!errorsSubmit?.description}
              />
            </Grid>
            <Grid item xs={4}>
              <TextFieldErp
                label="Complemento"
                value={complement}
                setValue={setComplement}
                maxLength="100"
                size="small"
                error={!!errorsSubmit?.complement}
              />
            </Grid>
            <Grid item xs={4}>
              <SelectErp
                error={!!errorsSubmit?.service}
                helperText={errorsSubmit?.service}
                label="Serviço"
                descriptionField="label"
                value={service}
                setValue={setService}
                optionsList={serviceList}
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                label="Ativo"
                control={
                  <Switch
                    checked={active}
                    onChange={() => setActive((currente) => !currente)}
                    color="primary"
                    onClick={(event) => event.stopPropagation()}
                    onFocus={(event) => event.stopPropagation()}
                  />
                }
              />
            </Grid>
          </Grid>
        </Line>

        {!!(companies.length > 1) && (
          <Line container spacing={1}>
            <Card line="left" padding="10" fullWidth>
              <Grid container>
                <Chip title="Empresas" label="Empresas" bgcolor="secondary" />
              </Grid>
              <Grid container>
                <Form>
                  {companies.map((company) => (
                    <CheckItem
                      key={company.id}
                      control={
                        <Checkbox
                          checked={company.check}
                          onChange={() => {
                            handleCheckCompany(company.id);
                          }}
                        />
                      }
                      label={company.apelido}
                    />
                  ))}
                </Form>
              </Grid>
            </Card>
          </Line>
        )}
      </Fieldset>
    </>
  );
};

export default AccordionDespesasDadosGerais;
